<template>
  <div class="wrapper">
    <div class="title">档案调阅授权同意书</div>
    <div class="content">
      <span>在您使用广东健康档案互通系统前，请仔细阅读以下内容：</span>
      <span>1.广东健康档案互通系统是根据《基本医疗卫生与健康促进法》等法律法规，以及《国家基本公共卫生服务规范（第三版）》、《广东省卫生健康委居民健康档案管理规范》等文件要求而设立的，用于建设居民健康档案，并对健康信息进行连续记录、动态更新。按照《民法典》《网络安全法》《个人信息保护法》《数据安全法》等有关规定，已采取合理可行的步骤去保障系统内各类信息的私隐、保密及安全。</span>
      <span>2.广东健康档案互通系统的健康档案是基于电子健康码为标识而建立的，并对个人的健康信息进行连续记录、动态更新。目前仅支持查看本人 2021 年 1 月以来在广东省二级及以上医疗机构的诊疗记录、健康体检、检验检查结果等信息，以及疫苗接种、献血用血等记录。</span>
      <span>3.广东健康档案互通系统仅用于居民查阅本人的健康档案，或经本人授权允许医疗机构查看个人的健康档案，用于改善医护服务效率和质量。当您点击本用户须知下方的“同意”按钮后，即表示允许所就诊的医疗机构可在 30 天内查看您的健康档案。如您需要取消所就诊的医疗机构查看权限，请在“粤健通”微信小程序的“健康档案调阅授权”进行取消操作。另外，您可通过“粤健通”微信小程序等移动服务平台查阅本人的健康档案信息。</span>
      <span>4.广东健康档案互通系统仅调取、汇聚医疗卫生机构提供的诊疗等信息，不负责对信息内容及时性、完整性、准确性进行审核。如您对健康档案中的信息有疑问，或需要订正资料的，请反馈给接诊医生，由接诊医生在广东健康档案互通系统的“问题反馈”页面登记问题，系统后台将自动分发给数源单位进行处理。您也可以通过“粤健通”微信小程序进行反映，或者咨询健康档案有关事宜。</span>
      <span>5.除根据法律法规有关规定及经本人同意外，广东健康档案互通系统的信息不向第三者转移或披露任何收集所得的资料。</span>
      <span>6.广东健康档案互通系统调用的信息，并非医疗机构完整的诊疗记录，不能取代医疗机构存储的任务记录，所展示的健康档案信息仅供参考，不作为任何凭证或依据使用。</span>
      <span class="label name">
        <span>授权人：</span>
        <span>{{ name }}</span>
      </span>
      <span class="label time">
        <span>授权时间：</span>
        <span>{{ time }}</span>
      </span>
    </div>
    <div class="btns">
      <span class="bty_btn" @click="cancel">不同意授权</span>
      <span class="ty_btn" @click="handleAut">同意授权</span>
    </div>
  </div>
</template>

<script>
import { GetRequest } from "@/tool/parameter.js";
import { Authorization } from "@/request/api.js";
export default {
  data(){
    return{
      name: GetRequest("name"),
      cardno: GetRequest("cardno")
    }
  },
  created() {
    this.time = this.$moment().format("YYYY-MM-DD");
  },
  methods: {
    async handleAut(){
      let map = {
        cardno: this.cardno
      }
      let res = await Authorization(map);
      if (res.data.message == "操作成功") {
        this.Toast.success("授权成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      } else {
        this.Toast(res.data.message);
      }
    },
    cancel(){
      this.$router.go(-1);
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .title{
    margin: 40px 0 20px 0;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 1px;
  }
  .content{
    margin: 0 16px;
    display: flex;
    flex-flow: column nowrap;
    font-family: SimHei;
    >span{
      margin-bottom: 8px;
      // text-indent: 2em;
      font-size: 14px;
      letter-spacing: 1px;
      font-weight: bold;
    }
    .label{
      text-indent: 0em;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      >span:nth-child(2){
        width: 90px;
      }
    }
    .name{
      margin: 20px 0 4px;
    }
  }
  .btns{
    margin: 10px 16px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    // background: #267dff;
    // border-radius: 4px;
    // color: white;
    // letter-spacing: 2px;
    // font-size: 14px;
    >span{
      text-align: center;
      border-radius: 4px;
      letter-spacing: 2px;
      font-size: 14px;
    }
    .bty_btn{
      line-height: 38px;
      width: 130px;
      border: 1px solid #267dff;
      color: #267dff;
    }
    .ty_btn{
      line-height: 40px;
      width: 190px;
      background: #267dff;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/PHRAccessAuthorize.vue